import { FileFormatError, FileFormatVersionError } from './errors';

import v1Importer from './v1Importer';
import v2Importer from './v2Importer';

const versionedImporters = {
  v1: v1Importer,
  v2: v2Importer,
};

const rawImporter = (importers) => (save, userId) => async (fileContent) => {
  let parsedMaterial;
  try {
    parsedMaterial = JSON.parse(fileContent);
  } catch (error) {
    throw new FileFormatError();
  }

  const { version } = Array.isArray(parsedMaterial)
    ? { version: 'v1', material: parsedMaterial }
    : parsedMaterial;

  const versionedImporter = importers[version];
  if (typeof versionedImporter === 'undefined') {
    throw new FileFormatVersionError();
  }

  return versionedImporter(save, userId, parsedMaterial);
};

export { rawImporter };
export default rawImporter(versionedImporters);
